import Vue from 'vue'

export const setStatus = (state, payload) => {
    state.status = payload
}
export const setMessage = (state, payload) => {
    state.message = payload
}